<svelte:options accessors/>

<script context="module" lang="ts">

</script>

<script lang="ts">
    import Icon, {ArrowDown, Download, Upload, X, XCircle} from 'svelte-hero-icons'
    import {createEventDispatcher, onMount} from 'svelte';
    import {fly, slide} from 'svelte/transition';
    import JewelGridItem from "./JewelGridItem.svelte";
    import JewelGrid from "./JewelGrid.svelte";

    const dispatch = createEventDispatcher();

    let title = 'hello';
    export let enabled = false;

    export let sections: any = []

    $: selectedSection = sections.find(v => !!v.selected)?.id??'';

    onMount(() => {
        dispatch('mounted', {})
    })
</script>

<!--<main class="text-gray-700 font-inter bg-transparent w-screen h-screen inset-0 absolute pointer-events-auto select-none"-->
<!--      style="background: url('assets/mesh-gradient-jewel.png')">-->
    <div class="bg-white w-auto bg-opacity-40 p-6 m-10 rounded-xl flex flex-row justify-end">
        <div class="bg-white rounded-xl w-auto h-auto" id="canvasContainer"></div>

        {#if (enabled)}

            <JewelGrid bind:items={sections}
                       bind:selected={selectedSection}
                       vertical="{true}" title=""
                       class="z-10 -ml-18"/>

            <!--        <div class="bg-transparent w-16 flex flex-col justify-around justify-items-stretch items-stretch px-2 py-1 -ml-16">-->
            <!--&lt;!&ndash;            <div class="bg-gray-200 bg-opacity-40 flex-grow my-1 rounded-md">T</div>&ndash;&gt;-->
            <!--&lt;!&ndash;            <div class="bg-gray-200 bg-opacity-40 flex-grow rounded-md">T</div>&ndash;&gt;-->
            <!--            <JewelGridItem class="flex-grow my-1 "/>-->
            <!--            <JewelGridItem class="flex-grow my-1 "/>-->
            <!--            <JewelGridItem class="flex-grow my-1 "/>-->
            <!--        </div>-->

            <div class="flex flex-col w-52">
                {#each sections as section}
                    {#if !!section.selected && section.sub}
                        {#each section.sub as sub_section}
                            <JewelGrid items="{sub_section.items}" title="{sub_section.title}"
                                       bind:selected={sub_section.selectedItem} on:select={(e)=>{
                                       let o = {
                                           section: section.id,
                                           sub: sub_section.id,
                                           obj: e.detail.jid,
                                           event: e.detail
                                       };
                                       dispatch('changeParam', o);
                                   }}
                            />
                        {/each}
                    {/if}
                {/each}
            </div>

        {/if}
    </div>

<!--</main>-->

<style global lang="postcss">
    @tailwind base;
    @tailwind components;
    @tailwind utilities;
    body {
        /*background-color:#ff0000;*/
        /*background-image: radial-gradient(at 41% 1%, hsla(350,100%,74%,1) 0, transparent 50%), radial-gradient(at 80% 0%, hsla(151,100%,56%,1) 0, transparent 50%), radial-gradient(at 0% 50%, hsla(317,85%,93%,1) 0, transparent 50%), radial-gradient(at 77% 45%, hsla(302,100%,76%,1) 0, transparent 50%), radial-gradient(at 0% 100%, hsla(344,100%,77%,1) 0, transparent 50%), radial-gradient(at 62% 79%, hsla(204,100%,70%,1) 0, transparent 50%), radial-gradient(at 0% 0%, hsla(305,100%,76%,1) 0, transparent 50%);*/
        background: black;
    }

    .font-inter {
        font-family: 'Inter', sans-serif !important;
    }

    .font-gilroy {
        font-family: 'Gilroy', sans-serif !important;
    }

</style>
